export default {
  path: '/car-management',
  component: () => import('@/views/car-management/Index'),
  children: [
    {
      path: 'cars',
      component: () => import('@/views/car-management/cars/Index'),
      children: [
        {
          path: '',
          name: 'car-management-cars-list',
          component: () => import('@/views/car-management/cars/List'),
          meta: {
            title: 'Cars',
            roles: ['general_manager', 'transfer_manager', 'transfer_supervisor', 'transfer_assistant']
          }
        },
        {
          path: ':id',
          component: () => import('@/views/car-management/cars/Detail'),
          children: [
            {
              path: '',
              name: 'car-management-cars-detail-licenses',
              component: () => import('@/views/car-management/cars/detail/Licenses'),
              meta: {
                roles: ['general_manager', 'transfer_manager', 'transfer_supervisor']
              }
            },
            {
              path: 'insurances',
              name: 'car-management-cars-detail-insurances',
              component: () => import('@/views/car-management/cars/detail/Insurances'),
              meta: {
                roles: ['general_manager', 'transfer_manager', 'transfer_supervisor']
              }
            },
            {
              path: 'odometer',
              name: 'car-management-cars-detail-odometer',
              component: () => import('@/views/car-management/cars/detail/Odometer'),
              meta: {
                roles: ['general_manager']
              }
            }
          ]
        },
      ]
    },
    {
      path: 'fuel-log',
      component: () => import('@/views/car-management/fuel-log/Layout'),
      children: [
        {
          path: '',
          name: 'car-management-fuel-log',
          component: () => import('@/views/car-management/fuel-log/Log'),
          meta: {
            title: 'Fuel log',
            roles: ['general_manager', 'accountant_supervisor', 'accountant_manager', 'transfer_manager', 'transfer_supervisor']
          }
        },
        {
          path: 'invalid',
          name: 'car-management-fuel-log-invalid',
          component: () => import('@/views/car-management/fuel-log/Invalid'),
          meta: {
            title: 'Fuel log',
            roles: ['general_manager', 'transfer_supervisor', 'transfer_manager']
          }
        },
        {
          path: 'vendors',
          name: 'car-management-fuel-log-vendors',
          component: () => import('@/views/car-management/fuel-log/Vendors'),
          meta: {
            title: 'Fuel log',
            roles: ['general_manager', 'accountant_supervisor', 'accountant_manager', 'transfer_manager', 'transfer_supervisor']
          }
        },
      ]
    },
  ]
}
